import { memo } from 'react';
import { useToggle } from '@dfl/hook-utils';
import DistributionCentersActions from './DistributionCentersActions';
import { useDeleteDistributionCenterWarehouse } from '../../hooks/useDeleteDistributionCenterWarehouse';
import { useWarehouseDetail } from 'modules/inventory/warehouse/context/WarehouseContext';

type Props = {
  rowId: string;
};

const CentersByWarehouseRowActions = ({ rowId }: Props) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const { warehouseId } = useWarehouseDetail();
  const { mutate, isPending, error } = useDeleteDistributionCenterWarehouse(rowId, [warehouseId], onClose);

  return (
    <>
      <DistributionCentersActions
        rowId={rowId}
        error={error}
        isLoading={isPending}
        onDelete={mutate}
        onClose={onClose}
        onOpen={onOpen}
        isOpen={isOpen}
      />
    </>
  );
};

export default memo(CentersByWarehouseRowActions);
